import React from 'react';
import WhoBanner from './WhoBanner';

// ES6 class-style
export default class WhoBanner2 extends WhoBanner {
  render() {
	  
  	return(
	<section className="bg-grn why-us">
		<div className="container"> 
			<h1>{this.rb("whobanner2.txt.1")}</h1> 
			<h2>{this.rb("whobanner.txt.2")}</h2>
		</div> 
	</section>
  	);
  }
}




// WEBPACK FOOTER //
// ./src/prelogin/src/components/WhoBanner2.js